module.exports = __webpack_public_path__ + "img/whats.f6a789fa.png";